<p>control-dungeon works!</p>